export default "__VITE_ASSET__9dpB1kBt__"